import { dateToYear, toDateTime, expandPath, notEmptyString, extractSeq, extractBool } from "./helpers";

export const filterValidWorks = work => {
  let valid = false;
  if (work instanceof Object) {
    if (work.mediaItems instanceof Array && work.mediaItems.length > 0) {
      valid = true;
    } else if (notEmptyString(work.description, 4)) {
      valid = true;
    }
  }
  return valid;
}

export const filterInvalidWorks = work => {
  const valid = work instanceof Object;
  if (valid) {
    return !filterValidWorks(work);
  }
  return valid;
}

export const mapSubmission = (row) => {
  let item = row;
  item.works = row.works instanceof Array ? row.works.map(mapWork) : [];
  if (!item.seq) {
    item.seq = extractSeq(item.user);
  }
  const hasUser = item.user instanceof Object;
  item.numWorks = item.works.length;
  item.numAllWorks = item.works.length;
  item.fullName = hasUser ? row.user.firstName + ' ' + row.user.lastName : '';
  item.firstName = hasUser ? row.user.firstName : '';
  item.lastName = hasUser ? row.user.lastName : '';
  item.uid = hasUser ? row.user.uid : 0;
  item.email = hasUser ? row.user.identifier : '';
  if (item.phones instanceof Array) {
    item.phones = item.phones.map(phone => {
      phone.text = phone.identifier;
      if (phone.notes) {
        phone.text += ' (' + phone.notes + ')';
      }
      return phone;
    })
  }
  item.birthDate = toDateTime(row.birthDate);
  item.hasCollectionAddress = row.collectionAddress instanceof Object && row.collectionAddress.street.length > 1;
  if (item.works.length > 0) {
    item.invalidWorks = item.works.filter(filterInvalidWorks);
    item.works = item.works.filter(filterValidWorks);
    item.numInvalidWorks = item.invalidWorks.length;
    item.numWorks = item.works.length;
  }
  item.numMediaItems = item.numWorks > 0 ? item.works.map(it => it.numMediaItems).reduce((a, b) => a + b, 0) : 0;
  item.numVideos = item.numWorks > 0 ? item.works.map(w => w.numVideos).reduce((a, b) => a + b, 0) : 0;
  item.hasVideo = item.numVideos > 0;
  item.numImages = item.numWorks > 0 ? item.works.map(w => w.numImages).reduce((a, b) => a + b, 0) : 0;
  item.hasImages = item.numImages > 0;
  item.numAudio = item.numWorks > 0 ? item.works.map(w => w.numAudio).reduce((a, b) => a + b, 0) : 0;
  item.hasAudio = item.numAudio > 0;
  item.longRead = extractBool(row, "longRead");
  item.startYearInt = dateToYear(row.startYear);
  item.endYearInt = dateToYear(row.endYear);
  item.createdAt = toDateTime(row.createdAt);
  item.modifiedAt = toDateTime(row.modifiedAt);
  return item;
}

export const mapWork = (row) => {
  let item = row;
  item.mediaItems = row.mediaItems instanceof Array ? row.mediaItems.filter(mi => mi instanceof Object).map(mapMediaItem) : [];
  item.numMediaItems = item.mediaItems.length;
  item.numVideos = row.mediaItems.filter(m => m.type === 'video').length;
  item.hasVideo = item.numVideos > 0;
  item.numImages = row.mediaItems.filter(m => m.type === 'image').length;
  item.hasImages = item.numImages > 0;
  item.numAudio = row.mediaItems.filter(m => m.type === 'audio').length;
  item.hasAudio = item.numAudio > 0;
  return item;
};

export const addStandardSizeSuffix = (fn) => {
  if (typeof fn === 'string') {
    const parts = fn.split('.');
    if (parts.length === 2) {
      fn = parts[0] + '-resize-1920-2560.' + parts[1];
    }
  }
  return fn;
}

const mapImageToItem = (item) => {
  let fn = item.filename;
  const qstr = '?t=' + (new Date().getTime() % 100000);
  switch (item.mime) {
    case 'image/jpeg':
    case 'image/png':
      fn = addStandardSizeSuffix(fn);
      break;
  }
  item.imgset = {
    src: expandPath(fn) + qstr,
    width: 1024,
    height: 576
  };
  if (item.attributes) {
    const { height, width } = item.attributes;
    item.imgset.width = width;
    item.imgset.height = height;
  }
  return item;
}

const mapVideoToItem = (item) => {
  if (!item.source) {
    item.source = 'vimeo';
  }
  if (item.source === 'vimeo') {
    if (!item.attributes) {
      item.attributes = {};
    }
    const { preview, width, height } = item.attributes;
    item.src = "https://player.vimeo.com/video/" + item.filename.split('//').pop();
    item.width = width ? width : 640;
    item.height = height ? height : 360;
    item.preview = preview;
    item.hasPreview = notEmptyString(preview, 2);
  }
}

export const mapMediaItem = (row) => {
  let item = row;
  const { type } = row;
  const typeRef = notEmptyString(type) ? type : "none";
  switch (typeRef) {
    case 'image':
      mapImageToItem(item);
      break;
    case 'video':
      mapVideoToItem(item);
      break;
    default:
      item.src = expandPath(item.filename);
      break;
  }
  return item;
};

export const mapUser = (row) => {
  const item = row instanceof Object ? row : {};
  const keys = Object.keys(item);
  if (keys.includes("seq") === false) {
    item.seq = extractSeq(item);
  }
  if (keys.includes("firstName") && keys.includes("lastName")) {
    item.fullName = row.firstName + ' ' + row.lastName;
  } else if (keys.includes("fullName")) {
    item.fullName = row.fullName;
  } else {
    item.fullName = row.identifier.split('@').shift().split('.').join(' ');
  }
  if (!item.firstName) {
    item.fullName = row.fullName;
    if (!keys.includes("firstName")) {
      const parts = row.fullName.split(" ");
      item.lastName = parts.pop();
    }
  }
  if (keys.includes('identifier')) {
    item.email = row.identifier;
    item.login = notEmptyString(row.login, 5) ? dateToYear(row.login) : "";
    item.createdAt = toDateTime(row.createdAt);
    item.modifiedAt = toDateTime(row.modifiedAt);
  }
  item.signUp = keys.includes("signUp") ? row.signUp : false;
  return item;
}

export const mapSetting = row => {
  let item = row;
  item.displayType = 'scalar';
  item.transform = "none";
  item.widget = "text";
  item.step = 0;
  item.options = [];
  switch (item.key) {
    case "work_validation_rule":
      item.widget = "select";
      item.options = [
        { key: "media", label: "At least 1 media item" },
        { key: "media_or_desc", label: "Media item or description" }
      ];
      break;
  }
  if (item.type) {
    switch (item.type) {
      case "array_string":
      case "array_integer":
      case "array_float":
        item.displayType = "list";
        item.widget = "textarea";
        item.transform = "option_key_values";
        break;
      case "key_value_array":
        item.displayType = "key_value_list";
        item.widget = "key_value_list";
        item.transform = "key_value_list";
        break;
      case "date":
      case "datetime":
        item.displayType = "date";
        item.widget = "date";
        break;
      case "integer":
        item.widget = "number";
        item.step = 1;
        break;
      case "currency":
        item.widget = "number-input";
        item.step = 0.01;
        break;
      case "float":
        item.widget = "number-input";
        item.step = 0.00001;
        break;
      case "boolean":
        item.widget = "checkbox";
        break;
    }
  }
  return item;
}


const translateResponse = (item, questions) => {
  if (item instanceof Object) {
    const { value } = item;
    if (item !== null) {
      switch (typeof item.value) {
        case 'boolean':
          return value ? "Yes" : "No";
        case 'string': {
          const qstn = questions.find(q => q._id === item.question);
          if (qstn) {
            if (['radio', 'select', 'select_other'].indexOf(qstn.type) >= 0) {
              const opt = qstn.options.find(op => op.key === value);
              if (opt) {
                return opt.text;
              }
            }
          }
          return value.replace(/_+/g, ' ');
        }
        default:
          return value;
      }
    }
  }
  return '';
}

export const mapSurvey = (row, questions) => {
  let item = row;
  item.numAnswers = 0;
  if (item.answers) {
    if (item.answers instanceof Array) {
      item.numAnswers = item.answers.length;
    }
  }
  item.hasAnswers = item.numAnswers > 0;
  if (item.hasAnswers) {
    item.answers = item.answers.map(ans => {
      ans.displayValue = translateResponse(ans, questions);
      return ans;
    })
  }
  return item;
}

export const matchDisabledSubmissionStatuses = (name) => {
  let disableItems = [];
  switch (name) {
    case 'ineligible':
      disableItems = ['deadlineException', 'paid_incomplete'];
      break;
    case 'paid_incomplete':
      disableItems = ['valid', 'submitted'];
      break;
    case 'submitted':
      disableItems = ['valid', 'paid_incomplete'];
      break;
    case 'valid':
      disableItems = ['submitted', 'paid_incomplete'];
      break;
    case 'checked':
      disableItems = [];
      break;
    case 'marked':
      disableItems = [];
      break;
    case 'deadlineException':
      disableItems = ['ineligible'];
      break;
  }
  return disableItems;
}

export const disableSubmissionStatuses = (submission, name) => {
  if (submission instanceof Object) {
    if (submission[name]) {
      let disableItems = matchDisabledSubmissionStatuses(name);
      if (disableItems.length > 0) {
        disableItems.forEach(key => {
          if (submission[key]) {
            submission[key] = false;
          }
        });
      }
    }
  }
}

export const extractSubAndWorkRefs = (submissions, subId, workId) => {
  const subIndex = submissions.findIndex(sub => sub._id === subId);
  let sub = null;
  let workIndex = -1;
  let work = null;
  if (subIndex >= 0) {
    sub = submissions[subIndex];
    if (sub instanceof Object) {
      workIndex = sub.works.findIndex(w => w._id === workId);
      if (workIndex >= 0) {
        work = sub.works[workIndex];
      }
    }
  }
  return {
    subIndex,
    sub,
    workIndex,
    work
  }
}

export const matchKeyValueOptions = key => {
  switch (key) {
    case 'art_media_lookup_validation':
      return [
        { key: "3d", label: "H x L x D (3D)" },
        { key: "2d", label: "H x W (2D)" },
        { key: "time", label: "Time (HH:)mm:ss" },
        { key: "desc", label: "Description required" },
        { key: "none", label: "No validation or size field" },
      ];
    default:
      return [];
  }
}
